export default "__VITE_ASSET__a41d29a4__"